import type * as T from "@shared/types";
import { axios } from ".";

const PAYOUT_BASE_URL = "/api/v1/finance-report";
export const PAYOUT_INVOICES_ENDPOINT = `${PAYOUT_BASE_URL}/order-headers`;
export const PAYOUT_INVOICE_ORDER_LINE_DETAILS_ENDPOINT = `${PAYOUT_BASE_URL}/order-line`;

export interface InvoiceDateRange {
  startDate?: string;
  endDate?: string;
  filterDateName?: T.InvoiceDateType;
}

export const getInvoiceDetails = async (dateRange?: InvoiceDateRange) => {
  const params: InvoiceDateRange = dateRange ?? {};

  // skipAuthLogout: during a Roaster Admin "switch roaster", the vendor context is torn
  // down before navigation. A stray refetch can hit /finance-report/order-headers without a vendorKey
  // header → authorizer 403. That is NOT an auth failure, so it must not run the
  // auth-error→logout pipeline (same reasoning as getVendors). Surfaces as a query error
  // instead of logging the admin out.
  const response = await axios.get<T.PurchaseOrderInvoiceResponse>(PAYOUT_INVOICES_ENDPOINT, { params, skipAuthLogout: true });
  return response.data.data;
};

export const getPurchaseOrderInvoiceLineDetails = async (purchaseOrderId: string) => {
  const response = await axios.get<T.PurchaseOrderInvoiceLineDetailsResponse>(PAYOUT_INVOICE_ORDER_LINE_DETAILS_ENDPOINT, {
    params: { purchaseOrderId },
    skipAuthLogout: true,
  });
  return response.data.data;
};
